var $eb50605dce43d0c0$exports = {};
// Percorso "I 4 compiti dei soldi": segna una tappa come completata.
// La chiave e' condivisa col check-up (stesso dominio): la pagina risultati
// legge lo stesso localStorage per mostrare i progressi nel tab mini corso.
const $eb50605dce43d0c0$var$STORAGE_KEY = 'pills_course_progress_v1';
function $eb50605dce43d0c0$var$readProgress() {
    try {
        return JSON.parse(localStorage.getItem($eb50605dce43d0c0$var$STORAGE_KEY)) || {};
    } catch (error) {
        return {};
    }
}
function $eb50605dce43d0c0$var$writeProgress(progress) {
    try {
        localStorage.setItem($eb50605dce43d0c0$var$STORAGE_KEY, JSON.stringify(progress));
    } catch (error) {
    // storage pieno o bloccato: il bottone resta solo visuale
    }
}
function $eb50605dce43d0c0$var$renderState(button, done) {
    button.classList.toggle('is-done', done);
    button.innerHTML = done ? '<i class="check" aria-hidden="true">\u2713</i> Tappa completata \xb7 tocca per togliere il segno' : 'Segna questa tappa come completata';
}
const $eb50605dce43d0c0$var$button = document.getElementById('courseCompleteToggle');
if ($eb50605dce43d0c0$var$button && $eb50605dce43d0c0$var$button.dataset.slug) {
    const slug = $eb50605dce43d0c0$var$button.dataset.slug;
    $eb50605dce43d0c0$var$renderState($eb50605dce43d0c0$var$button, Boolean($eb50605dce43d0c0$var$readProgress()[slug]));
    $eb50605dce43d0c0$var$button.addEventListener('click', ()=>{
        const progress = $eb50605dce43d0c0$var$readProgress();
        if (progress[slug]) delete progress[slug];
        else progress[slug] = Date.now();
        $eb50605dce43d0c0$var$writeProgress(progress);
        $eb50605dce43d0c0$var$renderState($eb50605dce43d0c0$var$button, Boolean(progress[slug]));
    });
}


//# sourceMappingURL=bot-e-btp.0eb30249.js.map
